import React from 'react';
import { Link } from 'react-router-dom';

const PolitiqueConfidentialite = () => {

  return (
    <div className="min-h-screen py-12 px-4 sm:px-6 lg:px-8" 
         style={{ background: 'linear-gradient(135deg, #7C3AED 0%, #A855F7 30%, #EC4899 60%, #F97316 100%)' }}>
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="flex flex-col items-center mb-4">
              <img 
                src="/logo-alo-advance.png" 
                alt="ALO ADVANCE" 
                className="h-24 w-24 drop-shadow-lg mb-2"
              />
              <p className="text-gray-600 text-sm font-semibold italic">Parce que Nous prévoyons Vos imprévus</p>
            </div>
            <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-orange-500 mb-2">
              Politique de Confidentialité
            </h1>
            <p className="text-gray-600">ALO ADVANCE - ALO FINANCES</p>
            <p className="text-sm text-gray-500">Dernière mise à jour : Octobre 2025</p>
          </div>

          {/* Contenu */}
          <div className="space-y-6 text-gray-700">
            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">1. Introduction</h2>
              <p className="mb-2">
                <strong>ALO FINANCES</strong>, éditeur de la plateforme <strong>ALO ADVANCE</strong>, 
                s'engage à protéger la vie privée et les données personnelles de ses utilisateurs.
              </p>
              <p>
                La présente Politique de Confidentialité décrit comment nous collectons, utilisons, stockons 
                et protégeons vos données personnelles conformément au <strong>RGPD (Règlement Général sur la Protection des Données)</strong> 
                et aux lois guinéennes en vigueur.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">2. Responsable du traitement</h2>
              <div className="bg-purple-50 p-4 rounded-lg">
                <p><strong>ALO FINANCES</strong></p>
                <p>Société de droit guinéen</p>
                <p>Siège social : Conakry, République de Guinée</p>
                <p>Email : dpo@alofinances.com</p>
                <p>Téléphone : +224 XXX XXX XXX</p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">3. Données collectées</h2>
              <h3 className="font-semibold text-purple-600 mb-2">3.1 Données d'inscription des entreprises</h3>
              <ul className="list-disc pl-6 space-y-1 mb-3">
                <li>Raison sociale</li>
                <li>Numéro RCCM (Registre du Commerce)</li>
                <li>NIF (Numéro d'Identification Fiscale) - optionnel</li>
                <li>Adresse complète</li>
                <li>Nom, prénom du contact principal</li>
                <li>Email et numéro de téléphone du contact</li>
                <li>Identifiants de connexion (email, mot de passe crypté)</li>
              </ul>
              
              <h3 className="font-semibold text-purple-600 mb-2">3.2 Données des employés</h3>
              <ul className="list-disc pl-6 space-y-1 mb-3">
                <li>Nom, prénom, matricule</li>
                <li>Numéro de téléphone</li>
                <li>Salaire mensuel</li>
                <li>Numéro de wallet mobile money</li>
                <li>Historique des transactions</li>
              </ul>

              <h3 className="font-semibold text-purple-600 mb-2">3.3 Données de navigation</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Adresse IP</li>
                <li>Type de navigateur et appareil</li>
                <li>Pages consultées et durée des visites</li>
                <li>Cookies et traceurs (avec votre consentement)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">4. Finalités du traitement</h2>
              <p className="mb-2">Vos données personnelles sont collectées et traitées pour les finalités suivantes :</p>
              <ul className="list-disc pl-6 space-y-1">
                <li><strong>Gestion des comptes :</strong> Création, authentification, administration</li>
                <li><strong>Fourniture du service :</strong> Traitement des avances sur salaire, paiements</li>
                <li><strong>Communication :</strong> Envoi de notifications, alertes, confirmations</li>
                <li><strong>Support client :</strong> Assistance technique et réponse aux demandes</li>
                <li><strong>Sécurité :</strong> Prévention de la fraude, sécurisation des transactions</li>
                <li><strong>Conformité légale :</strong> Respect des obligations réglementaires</li>
                <li><strong>Amélioration du service :</strong> Analyses statistiques, développement</li>
                <li><strong>Marketing :</strong> Information sur nos produits et services (avec votre accord)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">5. Base légale du traitement</h2>
              <p className="mb-2">Nous traitons vos données sur la base de :</p>
              <ul className="list-disc pl-6 space-y-1">
                <li><strong>Exécution du contrat :</strong> Fourniture des services ALO ADVANCE</li>
                <li><strong>Consentement :</strong> Communications marketing, cookies</li>
                <li><strong>Obligation légale :</strong> Conformité fiscale, lutte anti-blanchiment</li>
                <li><strong>Intérêt légitime :</strong> Sécurité de la plateforme, prévention de la fraude</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">6. Communications et notifications</h2>
              <div className="bg-orange-50 border-l-4 border-orange-500 p-4 rounded-r-lg mb-3">
                <p className="font-semibold text-orange-800 mb-2">📱 Utilisation de vos coordonnées</p>
                <p className="text-orange-700 mb-2">
                  En utilisant ALO ADVANCE, vous autorisez <strong>ALO FINANCES</strong> à vous contacter 
                  aux numéros de téléphone et adresses e-mail que vous avez fournis pour :
                </p>
                <ul className="list-disc pl-6 space-y-1 text-orange-700">
                  <li><strong>Notifications transactionnelles :</strong> Confirmations de paiement, alertes de sécurité, mises à jour de compte</li>
                  <li><strong>Notifications relatives au service :</strong> Maintenance, nouvelles fonctionnalités, changements de conditions</li>
                  <li><strong>Informations commerciales :</strong> Présentation d'autres produits et services ALO FINANCES</li>
                  <li><strong>Communications marketing :</strong> Offres promotionnelles, actualités de l'entreprise</li>
                  <li><strong>Enquêtes de satisfaction :</strong> Amélioration continue de nos services</li>
                </ul>
                <p className="mt-3 text-sm text-orange-600 font-medium">
                  💡 Vous pouvez à tout moment vous opposer aux communications marketing en cliquant sur le lien de désinscription 
                  présent dans nos emails ou en contactant notre service client. Les notifications transactionnelles 
                  essentielles au service ne peuvent pas être désactivées.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">7. Partage des données</h2>
              <p className="mb-2">Vos données peuvent être partagées avec :</p>
              <ul className="list-disc pl-6 space-y-1 mb-2">
                <li><strong>Prestataires techniques :</strong> Hébergement, maintenance (sous contrat de confidentialité)</li>
                <li><strong>Opérateurs mobile money :</strong> Pour le traitement des paiements</li>
                <li><strong>Autorités compétentes :</strong> Sur réquisition judiciaire ou administrative</li>
              </ul>
              <p className="font-semibold text-purple-600">
                ⚠️ ALO FINANCES ne vend jamais vos données personnelles à des tiers.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">8. Durée de conservation</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li><strong>Comptes actifs :</strong> Données conservées pendant toute la durée d'utilisation du service</li>
                <li><strong>Comptes fermés :</strong> Données supprimées après 3 ans (sauf obligations légales)</li>
                <li><strong>Transactions :</strong> Conservées 10 ans (obligation légale comptable)</li>
                <li><strong>Logs de connexion :</strong> Conservés 1 an (sécurité)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">9. Sécurité des données</h2>
              <p className="mb-2">ALO FINANCES met en œuvre des mesures techniques et organisationnelles pour protéger vos données :</p>
              <ul className="list-disc pl-6 space-y-1">
                <li><strong>Chiffrement :</strong> SSL/TLS pour toutes les communications</li>
                <li><strong>Cryptage :</strong> Mots de passe hashés avec algorithmes sécurisés</li>
                <li><strong>Accès restreint :</strong> Seul le personnel autorisé peut accéder aux données</li>
                <li><strong>Surveillance :</strong> Systèmes de détection des intrusions</li>
                <li><strong>Sauvegardes :</strong> Backups réguliers et sécurisés</li>
                <li><strong>Audits :</strong> Contrôles de sécurité périodiques</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">10. Vos droits</h2>
              <p className="mb-2">Conformément au RGPD, vous disposez des droits suivants :</p>
              
              <div className="space-y-2">
                <div className="bg-purple-50 p-3 rounded-lg">
                  <p className="font-semibold text-purple-700">✅ Droit d'accès</p>
                  <p className="text-sm">Obtenir une copie de vos données personnelles</p>
                </div>
                
                <div className="bg-purple-50 p-3 rounded-lg">
                  <p className="font-semibold text-purple-700">✏️ Droit de rectification</p>
                  <p className="text-sm">Corriger des données inexactes ou incomplètes</p>
                </div>
                
                <div className="bg-purple-50 p-3 rounded-lg">
                  <p className="font-semibold text-purple-700">🗑️ Droit à l'effacement</p>
                  <p className="text-sm">Demander la suppression de vos données (sous conditions)</p>
                </div>
                
                <div className="bg-purple-50 p-3 rounded-lg">
                  <p className="font-semibold text-purple-700">⛔ Droit d'opposition</p>
                  <p className="text-sm">Vous opposer au traitement de vos données (marketing, profilage)</p>
                </div>
                
                <div className="bg-purple-50 p-3 rounded-lg">
                  <p className="font-semibold text-purple-700">📦 Droit à la portabilité</p>
                  <p className="text-sm">Récupérer vos données dans un format structuré</p>
                </div>
                
                <div className="bg-purple-50 p-3 rounded-lg">
                  <p className="font-semibold text-purple-700">⏸️ Droit à la limitation</p>
                  <p className="text-sm">Limiter le traitement de vos données (sous conditions)</p>
                </div>
              </div>

              <div className="mt-4 bg-orange-50 border-l-4 border-orange-500 p-4 rounded-r-lg">
                <p className="font-semibold text-orange-800 mb-2">📧 Exercer vos droits</p>
                <p className="text-orange-700">
                  Pour exercer vos droits, contactez notre Délégué à la Protection des Données (DPO) :
                </p>
                <p className="text-orange-700 mt-2">
                  Email : <strong>dpo@alofinances.com</strong><br />
                  Courrier : ALO FINANCES - DPO, Conakry, Guinée
                </p>
                <p className="text-sm text-orange-600 mt-2">
                  Nous nous engageons à répondre dans un délai de 30 jours maximum.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">11. Cookies et traceurs</h2>
              <p className="mb-2">
                ALO ADVANCE utilise des cookies pour améliorer votre expérience. Vous pouvez gérer vos préférences 
                de cookies à tout moment dans les paramètres de votre navigateur.
              </p>
              <p className="text-sm text-gray-600">
                Types de cookies : essentiels (fonctionnement), analytiques (statistiques), marketing (avec consentement).
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">12. Transferts internationaux</h2>
              <p>
                Vos données sont hébergées en Guinée. En cas de transfert vers l'étranger, ALO FINANCES s'assure 
                que les garanties appropriées sont en place (clauses contractuelles types, Privacy Shield).
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">13. Modifications de la politique</h2>
              <p>
                ALO FINANCES se réserve le droit de modifier la présente Politique de Confidentialité. 
                Toute modification sera notifiée aux utilisateurs par email ou notification sur la plateforme.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">14. Réclamations</h2>
              <p className="mb-2">
                Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de :
              </p>
              <ul className="list-disc pl-6">
                <li>Notre DPO : dpo@alofinances.com</li>
                <li>L'autorité de protection des données compétente en Guinée</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-purple-700 mb-3">15. Contact</h2>
              <div className="bg-purple-50 p-4 rounded-lg">
                <p className="font-semibold mb-2">Pour toute question concernant vos données personnelles :</p>
                <p><strong>Délégué à la Protection des Données (DPO)</strong></p>
                <p>ALO FINANCES</p>
                <p>Email : dpo@alofinances.com</p>
                <p>Téléphone : +224 XXX XXX XXX</p>
                <p>Adresse : Conakry, République de Guinée</p>
              </div>
            </section>

            <div className="mt-6 p-4 bg-green-50 border-l-4 border-green-500 rounded-r-lg">
              <p className="text-green-800">
                <strong>🔒 Notre engagement :</strong> ALO FINANCES s'engage à respecter votre vie privée 
                et à protéger vos données personnelles avec le plus haut niveau de sécurité et de transparence.
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="mt-8 pt-6 border-t border-gray-200 text-center space-x-4">
            <Link
              to="/login"
              className="inline-block px-6 py-3 bg-gradient-to-r from-purple-600 to-orange-500 text-white font-semibold rounded-lg hover:from-purple-700 hover:to-orange-600 transition-all"
            >
              Retour à la connexion
            </Link>
            <Link
              to="/register"
              className="inline-block px-6 py-3 border-2 border-purple-600 text-purple-600 font-semibold rounded-lg hover:bg-purple-50 transition-all"
            >
              S'inscrire
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialite;
